export const BREAKDOWN_LIST = [
  {
    label: "Channel / Sub Channel",
    id: "1",
    detailedValue: "channel",
    simpleValue: "AssignedChannel"
  },
  {
    label: "Market Segment",
    id: "2",
    detailedValue: "marketSegmentCode",
    simpleValue: "AssignedMarketSegment"
  },
  {
    label: "Rate Category / Rate Plan",
    id: "3",
    detailedValue: "rateCategoryCode",
    simpleValue: "AssignedRateCategory"
  },
  {
    label: "Region / Country",
    id: "4",
    detailedValue: "region_cleaned",
    simpleValue: "AssignedRegion"
  }
];
